import { connect } from 'react-redux';
import { ReduxState } from 'kts-platform-frame/redux';

/**
 * 绑定组件
 * @param reduxStatePart 一个返回全局对象片段的方法
 * @param isForm 是否关联 Form
 */
function connectIndex(reduxStatePart: (state: ReduxState) => any) {
    const s2p = (state: any) => ({...reduxStatePart(state)});
    return (dom): any => (connect(s2p)(dom));
}

export default connectIndex;


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/redux/connect.ts